export const ACTIVITY_LOG_TAB_LABEL = "Activity log";
export const WAITLIST_TAB_LABEL = "Waitlist leads";
export const ANALYTICS_TAB_LABEL = "Analytics";
